"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = require("react");
var _agent = require("@deosite/agent");
var _router = _interopRequireDefault(require("next/router"));
var _useProductsBySkus = require("../useProductsBySkus");
var _LanguageProvider = require("../../common/LanguageProvider");
var _couponHit = _interopRequireDefault(require("@deosite/helpers/couponHit"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var skusActions = {
  notIncluded: function notIncluded(_ref) {
    var group = _ref.group,
      items = _ref.items,
      producer = _ref.producer,
      skus = _ref.skus;
    return group.every(function (sku) {
      return !skus.includes(sku);
    });
  },
  isOneOf: function isOneOf(_ref2) {
    var group = _ref2.group,
      items = _ref2.items,
      producer = _ref2.producer,
      skus = _ref2.skus;
    if (producer) {
      return items.find(function (item) {
        var _ref3, _item$product, _item$product$produce;
        return (_ref3 = (item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : (_item$product$produce = _item$product.producer) === null || _item$product$produce === void 0 ? void 0 : _item$product$produce.toUpperCase()) === (producer === null || producer === void 0 ? void 0 : producer.toUpperCase())) !== null && _ref3 !== void 0 ? _ref3 : false;
      });
    }
    return group.some(function (sku) {
      return skus.includes(sku);
    });
  }
};
var cartActions = {
  equalOrGreater: function equalOrGreater(_ref4) {
    var cartPrice = _ref4.cartPrice,
      conditionPrice = _ref4.conditionPrice;
    return cartPrice >= conditionPrice;
  }
};
var checkParticipatingSkus = function checkParticipatingSkus(_ref5) {
  var participatingSkus = _ref5.participatingSkus,
    itemsInCart = _ref5.itemsInCart,
    skusInCart = _ref5.skusInCart;
  if (!participatingSkus) {
    return true;
  }
  return participatingSkus.every(function (participating) {
    var _skusActions$particip;
    return (_skusActions$particip = skusActions[participating.type]) === null || _skusActions$particip === void 0 ? void 0 : _skusActions$particip.call(skusActions, {
      group: participating.group,
      items: itemsInCart,
      producer: participating.producer,
      skus: skusInCart
    });
  });
};
var checkCartTotalPriceWithProducer = function checkCartTotalPriceWithProducer(_ref6) {
  var _length, _ref7;
  var totals = _ref6.totals,
    cart = _ref6.cart;
  var producers = totals.producer,
    producerType = totals.producerType,
    producerQty = totals.producerQty,
    producerQtyType = totals.producerQtyType;
  var items = cart.items;
  var cartTotalPrice = 0;
  producers = producers.map(function (producer) {
    var _producer$toUpperCase;
    return (_producer$toUpperCase = producer === null || producer === void 0 ? void 0 : producer.toUpperCase()) !== null && _producer$toUpperCase !== void 0 ? _producer$toUpperCase : producer;
  });
  var itemsOfProducers = items.filter(function (item) {
    var _item$product$produce2, _item$product2, _item$product2$produc;
    return producers.includes((_item$product$produce2 = (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : (_item$product2$produc = _item$product2.producer) === null || _item$product2$produc === void 0 ? void 0 : _item$product2$produc.toUpperCase()) !== null && _item$product$produce2 !== void 0 ? _item$product$produce2 : false);
  });
  var producersInCartQty = (_length = (_ref7 = (0, _toConsumableArray2["default"])(new Set((0, _toConsumableArray2["default"])(itemsOfProducers.map(function (item) {
    return itemsOfProducers[item.producer];
  }))))) === null || _ref7 === void 0 ? void 0 : _ref7.length) !== null && _length !== void 0 ? _length : 0;
  if (producerType === "any" && producersInCartQty === 0) {
    return false;
  }
  if (producerType === "all" && producersInCartQty !== producers.length) {
    return false;
  }
  if (producerQty !== null) {
    var _cartActions$producer;
    var sumQty = itemsOfProducers.reduce(function (accumulator, item) {
      return accumulator + item.quantity;
    }, 0);
    if (cartActions !== null && cartActions !== void 0 && (_cartActions$producer = cartActions[producerQtyType]) !== null && _cartActions$producer !== void 0 && _cartActions$producer.call(cartActions, {
      cartPrice: sumQty,
      conditionPrice: producerQty
    })) {
      return cart === null || cart === void 0 ? void 0 : cart.totals.productsTotalPrice;
    }
  }
  itemsOfProducers.forEach(function (item) {
    var _item$product3, _item$product3$produc;
    if (producers.includes(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : (_item$product3$produc = _item$product3.producer) === null || _item$product3$produc === void 0 ? void 0 : _item$product3$produc.toUpperCase())) {
      var _item$product4, _item$product4$price, _item$product5, _item$product5$price, _item$product6, _item$product6$price;
      var price = item !== null && item !== void 0 && (_item$product4 = item.product) !== null && _item$product4 !== void 0 && (_item$product4$price = _item$product4.price) !== null && _item$product4$price !== void 0 && _item$product4$price.special ? item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : (_item$product5$price = _item$product5.price) === null || _item$product5$price === void 0 ? void 0 : _item$product5$price.special : item === null || item === void 0 ? void 0 : (_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : (_item$product6$price = _item$product6.price) === null || _item$product6$price === void 0 ? void 0 : _item$product6$price.regular;
      cartTotalPrice += price * item.quantity;
    }
  });
  return cartTotalPrice;
};
var promotionActions = {
  redirectToPdp: function redirectToPdp(_ref8) {
    var _skusGift$every;
    var condition = _ref8.condition,
      cart = _ref8.cart,
      setSkusToWatch = _ref8.setSkusToWatch,
      couponCode = _ref8.couponCode;
    var participatingSkus = condition.participatingSkus,
      skusGift = condition.skusGift,
      date = condition.date,
      totalsCart = condition.totalsCart,
      redirectUrl = condition.redirectUrl;
    var itemsInCart = cart.items;
    var skusInCart = cart.items.map(function (item) {
      return item.sku;
    });
    var isValidCondition = checkParticipatingSkus({
      participatingSkus: participatingSkus,
      itemsInCart: itemsInCart,
      skusInCart: skusInCart
    });
    var isValidSkusGift = (_skusGift$every = skusGift === null || skusGift === void 0 ? void 0 : skusGift.every(function (gift) {
      var _skusActions$gift$typ;
      return (_skusActions$gift$typ = skusActions[gift.type]) === null || _skusActions$gift$typ === void 0 ? void 0 : _skusActions$gift$typ.call(skusActions, {
        group: gift.group,
        skus: skusInCart
      });
    })) !== null && _skusGift$every !== void 0 ? _skusGift$every : true;
    var cartTotalPrice = cart === null || cart === void 0 ? void 0 : cart.totals.productsTotalPrice;
    if (totalsCart !== null && totalsCart !== void 0 && totalsCart.producer) {
      cartTotalPrice = checkCartTotalPriceWithProducer({
        totals: totalsCart,
        cart: cart
      });
    }
    var isValidPrice = cartActions === null || cartActions === void 0 ? void 0 : cartActions[totalsCart.type]({
      cartPrice: cartTotalPrice,
      conditionPrice: totalsCart.price
    });
    if (isValidCondition && isValidSkusGift && isValidPrice && validDate(_objectSpread({}, date))) {
      setSkusToWatch({
        skus: skusGift[0].group,
        couponCode: couponCode
      });
      _router["default"].push(redirectUrl, redirectUrl, {
        shallow: true
      });
      return skusGift[0].group;
    }
    return false;
  },
  addToCart: function () {
    var _addToCart = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref9) {
      var _skusGift$every2;
      var condition, cart, couponCode, addCouponCode, addProduct, language, participatingSkus, skusGift, date, totalsCart, productAddedToCart, itemsInCart, skusInCart, isValidCondition, isValidSkusGift, cartTotalPrice, isValidPrice, products;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              condition = _ref9.condition, cart = _ref9.cart, couponCode = _ref9.couponCode, addCouponCode = _ref9.addCouponCode, addProduct = _ref9.addProduct, language = _ref9.language;
              participatingSkus = condition.participatingSkus, skusGift = condition.skusGift, date = condition.date, totalsCart = condition.totalsCart, productAddedToCart = condition.productAddedToCart;
              itemsInCart = cart.items;
              skusInCart = cart.items.map(function (item) {
                return item.sku;
              });
              isValidCondition = checkParticipatingSkus({
                participatingSkus: participatingSkus,
                itemsInCart: itemsInCart,
                skusInCart: skusInCart
              });
              isValidSkusGift = (_skusGift$every2 = skusGift === null || skusGift === void 0 ? void 0 : skusGift.every(function (gift) {
                var _skusActions$gift$typ2;
                return (_skusActions$gift$typ2 = skusActions[gift.type]) === null || _skusActions$gift$typ2 === void 0 ? void 0 : _skusActions$gift$typ2.call(skusActions, {
                  group: gift.group,
                  skus: skusInCart
                });
              })) !== null && _skusGift$every2 !== void 0 ? _skusGift$every2 : true;
              cartTotalPrice = cart === null || cart === void 0 ? void 0 : cart.totals.productsTotalPrice;
              if (totalsCart !== null && totalsCart !== void 0 && totalsCart.producer) {
                cartTotalPrice = checkCartTotalPriceWithProducer({
                  totals: totalsCart,
                  cart: cart
                });
              }
              isValidPrice = cartActions === null || cartActions === void 0 ? void 0 : cartActions[totalsCart.type]({
                cartPrice: cartTotalPrice,
                conditionPrice: totalsCart.price
              });
              if (!(isValidCondition && isValidSkusGift && isValidPrice && validDate(_objectSpread({}, date)))) {
                _context.next = 20;
                break;
              }
              _context.next = 12;
              return (0, _useProductsBySkus.fetcher)({
                skus: productAddedToCart,
                language: language
              });
            case 12:
              products = _context.sent;
              if (!(products.length === 0)) {
                _context.next = 15;
                break;
              }
              return _context.abrupt("return", false);
            case 15:
              _context.next = 17;
              return Promise.all(products.map(function (product) {
                return addProduct(product, 1);
              }));
            case 17:
              _context.next = 19;
              return addCouponCode(couponCode, false);
            case 19:
              return _context.abrupt("return", productAddedToCart);
            case 20:
              return _context.abrupt("return", false);
            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function addToCart(_x) {
      return _addToCart.apply(this, arguments);
    }
    return addToCart;
  }()
};
var validDate = function validDate(_ref0) {
  var start = _ref0.start,
    end = _ref0.end;
  var currentDate = Date.now();
  start = typeof start !== "number" ? new Date(start).getTime() : start;
  end = typeof end !== "number" ? new Date(end).getTime() : end;
  return start < currentDate && end > currentDate;
};
var usePromotions = function usePromotions(_ref1) {
  var cart = _ref1.cart,
    addCouponCode = _ref1.addCouponCode,
    addProduct = _ref1.addProduct;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useState = (0, _react.useState)(null),
    skusPromotion = _useState[0],
    setSkusPromotion = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    skusToWatch = _useState2[0],
    setSkusToWatch = _useState2[1];
  var isPending = (0, _react.useRef)(false);
  var getSkus = /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _agent.requests.getExternal("".concat(global.__appConfig__.promotionsUrl));
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function getSkus() {
      return _ref10.apply(this, arguments);
    };
  }();
  var getAndSetPromotionsSkus = /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var skusData;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!isPending.current) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              isPending.current = true;
              _context3.prev = 3;
              _context3.next = 6;
              return getSkus();
            case 6:
              skusData = _context3.sent;
              setSkusPromotion(skusData);
              isPending.current = false;
              return _context3.abrupt("return", skusData);
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](3);
              console.log("Get Promotions error - ".concat(_context3.t0));
            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 12]]);
    }));
    return function getAndSetPromotionsSkus() {
      return _ref11.apply(this, arguments);
    };
  }();
  var hasPromotionsAndItems = function hasPromotionsAndItems(skus) {
    var _cart$items;
    return skus && Object.values(skus).length > 0 && (cart === null || cart === void 0 ? void 0 : (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.length) > 0;
  };
  var getPromotions = /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var _cart$items2;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!skusPromotion && (cart === null || cart === void 0 ? void 0 : (_cart$items2 = cart.items) === null || _cart$items2 === void 0 ? void 0 : _cart$items2.length) > 0)) {
                _context4.next = 4;
                break;
              }
              _context4.next = 3;
              return getAndSetPromotionsSkus();
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
              return _context4.abrupt("return", skusPromotion);
            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function getPromotions() {
      return _ref12.apply(this, arguments);
    };
  }();
  var findCouponCode = function findCouponCode(_ref13) {
    var couponsCode = _ref13.couponsCode,
      couponCodeToFind = _ref13.couponCodeToFind;
    return couponsCode === null || couponsCode === void 0 ? void 0 : couponsCode.find(function (couponCode) {
      return couponCode.name.toUpperCase() === couponCodeToFind.toUpperCase();
    });
  };
  var checkCouponBeforeSendToMagento = /*#__PURE__*/function () {
    var _ref14 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(couponCode) {
      var skus, foundCouponCode, _promotionActions$fou, result;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return getPromotions();
            case 2:
              skus = _context5.sent;
              _context5.prev = 3;
              foundCouponCode = findCouponCode({
                couponsCode: skus,
                couponCodeToFind: couponCode
              });
              if (!(hasPromotionsAndItems(skus) && foundCouponCode)) {
                _context5.next = 10;
                break;
              }
              _context5.next = 8;
              return promotionActions === null || promotionActions === void 0 ? void 0 : (_promotionActions$fou = promotionActions[foundCouponCode.action]) === null || _promotionActions$fou === void 0 ? void 0 : _promotionActions$fou.call(promotionActions, {
                condition: foundCouponCode === null || foundCouponCode === void 0 ? void 0 : foundCouponCode.condition,
                cart: cart,
                addCouponCode: addCouponCode,
                addProduct: addProduct,
                setSkusToWatch: setSkusToWatch,
                couponCode: couponCode,
                language: language
              });
            case 8:
              result = _context5.sent;
              return _context5.abrupt("return", result);
            case 10:
              _context5.next = 16;
              break;
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](3);
              return _context5.abrupt("return", false);
            case 16:
              return _context5.abrupt("return", false);
            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 12]]);
    }));
    return function checkCouponBeforeSendToMagento(_x2) {
      return _ref14.apply(this, arguments);
    };
  }();
  var isCouponFromPromotions = /*#__PURE__*/function () {
    var _ref15 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(couponCode) {
      var skus;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(couponCode === (0, _couponHit["default"])(language.language))) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", true);
            case 2:
              _context6.next = 4;
              return getPromotions();
            case 4:
              skus = _context6.sent;
              return _context6.abrupt("return", !!findCouponCode({
                couponsCode: skus,
                couponCodeToFind: couponCode
              }));
            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function isCouponFromPromotions(_x3) {
      return _ref15.apply(this, arguments);
    };
  }();
  var isProductFromPromotions = function isProductFromPromotions(newSku) {
    var isProductPageHit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    try {
      if (isProductPageHit) {
        addCouponCode((0, _couponHit["default"])(language.language), false)["catch"](console.error);
      } else if (skusToWatch && skusToWatch.skus.includes(newSku)) {
        addCouponCode(skusToWatch.couponCode, false);
        setSkusToWatch(null);
      }
    } catch (error) {
      console.log("Problem with product from promotion: ".concat(error));
    }
  };
  return {
    checkCouponBeforeSendToMagento: checkCouponBeforeSendToMagento,
    isProductFromPromotions: isProductFromPromotions,
    isCouponFromPromotions: isCouponFromPromotions
  };
};
var _default = usePromotions;
exports["default"] = _default;